<!-- Navigation -->
<calsoft-vertical-navigation [appearance]="'thin'" [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'"
    [navigation]="data.navigation.compact[0]" [opened]="!isScreenSmall">

    <div calsoftVerticalNavigationContentHeader>
        <div class="logo">
            <img [src]="path" onerror="this.src='assets/images/logo/2.png';" alt="">
        </div>
    </div>

</calsoft-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">

        <!-- Navigation toggle button -->
        <button [guide]="'thin-btn-1' + '__' + sanitizeUrl(url)" class="navigation-toggle-button" mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'menu'"></mat-icon>
        </button>

        <div fxHide.lt-md class="flex items-center tour-controls hide-mobile">
            <div *ngIf="!opened" class="search-pill-bar"
                [attr.guide]="'compact-btn-search-select' + '__' + sanitizeUrl(url)"
                (click)="searchType === 'menu' ? open() : goToPopUp()">
                <mat-icon class="search-pill-icon">search</mat-icon>
                <span class="search-pill-placeholder">{{ searchType === 'crm' ? 'Search CRM' : 'Search Menu' }}</span>
                <mat-icon [matMenuTriggerFor]="searchMenu" class="search-pill-arrow"
                    (click)="$event.stopPropagation()">arrow_drop_down</mat-icon>
            </div>
            <mat-menu #searchMenu="matMenu">
                <button mat-menu-item (click)="searchType = 'menu'; open()">
                    <mat-icon>search</mat-icon>
                    <span>Search Menu</span>
                </button>
                <button mat-menu-item (click)="searchType = 'crm'; goToPopUp()">
                    <mat-icon>manage_search</mat-icon>
                    <span>Search CRM</span>
                </button>
            </mat-menu>
        </div>


        <div fxFlex="40" fxFlex.lt-md="100" *ngIf="opened" fxLayoutAlign="center center">
            <mat-icon style="width: 30px;">search</mat-icon>
            &nbsp;
            <input [attr.guide]="'compact-inp-2' + '__' + sanitizeUrl(url)" #searchInput class="w-full h-full"
                [formControl]="searchControl" [matAutocomplete]="matAutocomplete" [placeholder]="'Search Menu ....'"
                (keydown)="onKeydown($event)" />
            <mat-autocomplete class="max-h-128 sm:px-2 border-t rounded-b shadow-md" [autoSelectActiveOption]="true"
                [disableRipple]="true" #matAutocomplete="matAutocomplete">
                <mat-option class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                    *ngIf="resultSets && !resultSets.length">
                    No results found!
                </mat-option>
                <ng-container *ngFor="let resultSet of resultSets; trackBy:
                 trackByFn">
                    <mat-optgroup class="flex items-center mt-2 px-2">
                        <span class="text-sm font-semibold tracking-wider 
                        text-secondary">
                            {{resultSet.label.toUpperCase()}}</span>
                    </mat-optgroup>
                    <ng-container *ngFor="let result of resultSet.results; trackBy:
                     trackByFn">
                        <mat-option class="group relative mb-1 py-0 px-6 text-md 
                            rounded-md hover:bg-gray-100 dark:hover:bg-hover" [value]="result.value"
                            (onSelectionChange)="$event.isUserInput && getToRoute(result.link)">


                            <ng-container *ngIf="resultSet.id === 'contacts'">
                                <ng-container
                                    *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                            </ng-container>

                            <ng-container *ngIf="resultSet.id === 'pages'">
                                <ng-container
                                    *ngTemplateOutlet="pageResult; context: {$implicit: result}"></ng-container>
                            </ng-container>

                            <ng-container *ngIf="resultSet.id === 'tasks'">
                                <ng-container
                                    *ngTemplateOutlet="taskResult; context: {$implicit: result}"></ng-container>
                            </ng-container>
                        </mat-option>
                    </ng-container>
                </ng-container>
            </mat-autocomplete>
            <button [attr.guide]="'compact-btn-3' + '__' + sanitizeUrl(url)" fxLayoutAlign="center center"
                class="buttonie" mat-icon-button (click)="close()">
                <mat-icon (click)="isVisibleSearch = !isVisibleSearch">close</mat-icon>
            </button>
        </div>

        <ng-template #contactResult let-result>
            <div class="flex items-center">
                <div class="flex shrink-0 items-center 
                  justify-center w-8 h-8 rounded-full overflow-hidden bg-primary-100 dark:bg-primary-800">
                    <img *ngIf="result.avatar" [src]="result.avatar">
                    <mat-icon>search</mat-icon>
                </div>
                <div class="ml-3 truncate">
                    <span [innerHTML]="result.name"></span>
                </div>
            </div>
        </ng-template>

        <!-- Page result template -->
        <ng-template #pageResult let-result class="hide-mobile">
            <div (click)="getToRoute(result.link)" class="flex flex-col">
                <div class="truncate leading-normal" [innerHTML]="result.defaultName || result.title"></div>
                <div class="truncate leading-normal text-sm text-secondary">
                    {{result.link}}
                </div>
            </div>
        </ng-template>

        <!-- Task result template -->
        <ng-template #taskResult let-result class="hide-mobile">
            <div class="flex items-center">
                <ng-container *ngIf="result.completed">
                    <mat-icon class="mr-0 text-primary dark:text-primary-400">add</mat-icon>
                </ng-container>
                <ng-container *ngIf="!result.completed">
                    <mat-icon class="mr-0 text-hint" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
                </ng-container>
                <div class="ml-3 truncate leading-normal" [ngClass]="{'line-through text-hint': result.completed}"
                    [innerHTML]="result.title"></div>
            </div>
        </ng-template>

        <!-- Spacer removed to allow header-user to center content -->
        <calsoft-header-user fxFlex></calsoft-header-user>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <!-- Footer -->
    <!-- <div class="footer">
        Calsoft &copy; {{currentYear}}
    </div> -->

</div>